import React from 'react';
import { BankOrCreditUnion, Person } from 'schema-dts';
import { JsonLd } from 'react-schemaorg';
import {
  FetchBranchResult,
  OpeninghoursResult,
  FetchEmployeeResult
} from '../types';
import config from '../config';

export function BankOrCreditUnionSchema(branch: FetchBranchResult) {
  const dayMap: any = {
    Mandag: 'Mo',
    Tirsdag: 'Tu',
    Onsdag: 'We',
    Torsdag: 'Th',
    Fredag: 'Fr',
    Lørdag: 'Sa',
    Søndag: 'Su'
  };

  const branchUrl =
    config.apiBasePath + config.baseUrl + '/' + branch.friendlyName;

  const OpeningHoursSchema = (openingHours: OpeninghoursResult[]) => {
    return openingHours
      ? openingHours.map((opening: any) => {
          return (
            dayMap[opening.day] + ' ' + opening.openingTime.replace(/\s/g, '')
          );
        })
      : '';
  };

  return (
    <JsonLd<BankOrCreditUnion>
      item={{
        '@context': 'https://schema.org',
        '@type': 'BankOrCreditUnion',
        name: branch.branchName,
        image: branch.url,
        telephone: branch.telephone,
        faxNumber: branch.fax,
        email: branch.email,
        url: branchUrl.toLowerCase(),
        openingHours: OpeningHoursSchema(branch.openingHours),
        address: branch.address
      }}
    />
  );
}

type EmployeeSchemaType = FetchEmployeeResult & {
  branchUrl: string | undefined;
};

export function EmployeeSchema(employee: EmployeeSchemaType) {
  const employeeName = `${employee.firstName} ${employee.lastName}`
    .toLowerCase()
    .replace(/ /g, '-');

  const employeePageUrl = `${config.apiBasePath}${config.baseUrl}${employee.branchUrl}/${employee.userId}/${employeeName}`;
  const employeeImageUrl = `${config.apiBasePath}${employee.url}.jpg`;
  return (
    <JsonLd<Person>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Person',
        image: employeeImageUrl,
        name: employee.firstName + ' ' + employee.lastName,
        jobTitle: employee.title,
        telephone: employee.phone,
        email: employee.email,
        url: employeePageUrl
      }}
    />
  );
}
